import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';

var Config = require('../../../config');
var socket = '';

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.printSampleLabel = this.printSampleLabel.bind(this)

		this.state = {
			show: false,
			purchase_date:"",
			purchase_folio:"",
			entry_date:"",
			provider:"",
			distributor:"",
			details:[],
			preview_print:{}
		}
	}

	componentDidMount(){
		this.props.onRef(this);
		
		if(this.props.socket !== undefined  && this.props.socket !== ""){
			socket= this.props.socket;
		}else{
			socket= new WebSocket("wss://localhost:2018");
		}
		

		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}
	}

	handleShow(item){
		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product_purschase/'+item.purschase.id,{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show: true,
					purchase_date:item.purschase.purchase_date,
					purchase_folio:item.purschase.purchase_folio,
					entry_date:item.purschase.entry_date,
					provider:item.provider,
					distributor:item.distributor,
					details:response.detail
				});
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
			entry:[],
		});
	}

	printSampleLabel(e, id){
		e.preventDefault();
	
		this.props.waiting.handleShow('Imprimiendo...');

		var obj ={};
		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.id = id;
		obj.file_type = "label_products";
		obj.nEtiqueta = [];

		fetch(Config.default.apiGateway.URL+"labelsEditor", {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
				return;
			  });
			}
		})
		.then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = function() {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						socket.send('{"Operacion":"print", "Type":"label_sample_patients", "File": "'+aux[1]+'"}');
					}
				}
				
			}
		});
			
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Entrada</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Fabricante</span>
		        				<input type="text" className="form-control" value={this.state.provider} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.distributor} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">F. Entrada</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.entry_date !== "" ? moment(this.state.entry_date).format('DD/MM/YYYY') : ""} />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Folio Factura</span>
		        				<input type="text" className="form-control" value={this.state.purchase_folio || ""} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">F. Factura</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.purchase_date !== "" ? 
		        						moment(this.state.purchase_date).format('DD/MM/YYYY') : ""} />
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			
		        			<Table responsive hover>
		        				<thead>
				                  	<tr>
				                  		<th>Producto</th>
					                    <th>Lote</th>
					                    <th>Fecha Caducidad</th>
					                    <th>Cantidad</th>
					                    <th>Costo</th>
					                    <th></th>
				                  	</tr>
				                </thead>
				                <tbody>
				                 	{this.state.details.map( (d, index) => (
				                    	<tr key={index}>
				                    		<td>{d.name}</td>
				                      		<td>{d.lot_number}</td>
						                    <td>{moment(d.expiration_date).format('DD/MM/YYYY')}</td>
						                    <td>{d.amount}</td>
						                    <td>{d.cost_unit_entry !== null ? '$ '+d.cost_unit_entry.toFixed(2) : ''}</td>
						                    <td>
												<SvgIcon size={20} icon={ic_local_offer}
													onClick={(e)=>this.printSampleLabel(e, d.id)}
													style={{cursor:'pointer'}} />
											</td>
				                    	</tr>
				                  	))}
				                </tbody>
		        			</Table>

		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalDetails);